/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { theme } from '../../styles/theme'
import { Button } from '../UI/Button'

interface HeroSectionProps {
  isAffiliate: boolean
}

const heroStyles = css`
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
  color: white;
  padding: 24px 0;
  margin-bottom: 50px;
`

export const HeroSection = ({ isAffiliate }: HeroSectionProps) => {
  const subheading = isAffiliate 
    ? "Sign up as an affiliate and earn rewards for sharing"
    : "Exclusive Tactical Asset Allocation Strategies"

  return (
    <div css={heroStyles}>
      <div className="container text-center">
        <p className="lead mb-0">{subheading}</p>
        <div className="mt-3">
          <a href="#getting-started">
            <Button variant="get-started" size="sm">
              GET STARTED
            </Button>
          </a>
        </div>
      </div>
    </div>
  )
}